import { DefaultState, MassAddResponse, MergeLodgingOptionsRow } from 'store/types';

export const MERGE_LODGING_OPTION_REQUEST = 'MERGE_LODGING_OPTION_REQUEST';
export const MERGE_LODGING_OPTION_SUCCESS = 'MERGE_LODGING_OPTION_SUCCESS';
export const MERGE_LODGING_OPTION_FAILURE = 'MERGE_LODGING_OPTION_FAILURE';

export interface LodgingOptionMergeRow extends MergeLodgingOptionsRow {
  reservationId: string;
  reservationProviderId: string;
  reservationProviderName: string;
  status: string;
  totalRate: string;
  fromDate: string;
  toDate: string;
}

export type LodgingOptionMergeData = MassAddResponse<LodgingOptionMergeRow>

export interface MergeLodgingOptionParams {
  toLodgingOptionId: string;
  fromLodgingOptionId: string;
  isLodgingDelete: boolean;
};

export interface MergeLodgingOptionData {

};

export type MergeLodgingOptionState = DefaultState & {
  contents?: MergeLodgingOptionData;
};

interface MergeLodgingOptionRequest {
  type: typeof MERGE_LODGING_OPTION_REQUEST;
};

interface MergeLodgingOptionSuccess {
  type: typeof MERGE_LODGING_OPTION_SUCCESS,
  contents: MergeLodgingOptionData;
}

interface MergeLodgingOptionFailure {
  type: typeof MERGE_LODGING_OPTION_FAILURE;
}

export type MergeLodgingOptionActionTypes = MergeLodgingOptionRequest | MergeLodgingOptionSuccess | MergeLodgingOptionFailure;